module.exports = __webpack_public_path__ + "img/quizz-step-5-3.3050465c.jpg";